/* Hey Namastey — shared scroll animations. Loaded once per page via the hn-core snippet.
   Safe to run many times: every element is marked once it has been wired up, so new
   sections added in the Theme Editor animate correctly without a page refresh. */
(function () {
  'use strict';

  // Each HN section links this file, so the tag can appear more than once on a page.
  if (window.__hnCore) return;
  window.__hnCore = true;

  function countUp(el) {
    var end = +el.dataset.count,
      suf = el.dataset.suffix || '',
      dur = 1400,
      t0 = performance.now();
    (function step(t) {
      var p = Math.min((t - t0) / dur, 1),
        e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e) + suf;
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  var io = null;
  function observer() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('in');
          [].forEach.call(en.target.querySelectorAll('[data-count]'), countUp);
          io.unobserve(en.target);
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
    );
    return io;
  }

  function reveals(root) {
    var els = [].slice.call(root.querySelectorAll('.hn [data-reveal]')).filter(function (el) {
      return !el.dataset.hnReveal;
    });
    var obs = observer();
    els.forEach(function (el, i) {
      el.dataset.hnReveal = '1';
      el.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
      if (obs) obs.observe(el);
      else el.classList.add('in');
    });
  }

  function faqs(root) {
    [].forEach.call(root.querySelectorAll('.hn .faq-grid .qa'), function (q) {
      if (q.dataset.hnFaq) return;
      q.dataset.hnFaq = '1';
      q.addEventListener('click', function () {
        q.classList.toggle('open');
      });
    });
  }

  var timelines = [];
  function drawTimelines() {
    var vh = window.innerHeight;
    timelines.forEach(function (tl) {
      var r = tl.el.getBoundingClientRect();
      var p = Math.max(0, Math.min(1, (vh * 0.6 - r.top) / r.height));
      if (tl.line) tl.line.style.setProperty('--tl', p);
      tl.steps.forEach(function (s, i) {
        s.classList.toggle('lit', p >= (i + 0.4) / tl.steps.length);
      });
    });
  }

  function bindTimelines(root) {
    [].forEach.call(root.querySelectorAll('.hn .timeline'), function (el) {
      if (el.dataset.hnTl) return;
      el.dataset.hnTl = '1';
      timelines.push({
        el: el,
        line: el.querySelector('.tl-line'),
        steps: [].slice.call(el.querySelectorAll('.tstep'))
      });
    });
    drawTimelines();
  }

  var layers = [];
  function parallax() {
    var y = window.pageYOffset;
    layers.forEach(function (l) {
      var p = parseFloat(l.getAttribute('data-par')) || 0;
      l.style.transform = 'translateY(' + y * p + 'px)';
    });
  }

  function bindLayers(root) {
    [].forEach.call(root.querySelectorAll('.hn .scene .s-layer'), function (el) {
      if (el.dataset.hnPar) return;
      el.dataset.hnPar = '1';
      layers.push(el);
    });
    parallax();
  }

  var vids = [];
  function playVids() {
    vids.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.loop = true;
      v.playsInline = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    });
  }

  function bindVideos(root) {
    [].forEach.call(root.querySelectorAll('.hn video'), function (v) {
      if (v.dataset.hnVid) return;
      v.dataset.hnVid = '1';
      vids.push(v);
    });
    if (vids.length) playVids();
  }

  var globalsBound = false;
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;
    window.addEventListener('scroll', drawTimelines, { passive: true });
    window.addEventListener('scroll', parallax, { passive: true });
    window.addEventListener('resize', drawTimelines, { passive: true });
    ['pointerdown', 'touchstart', 'scroll', 'mousemove', 'keydown'].forEach(function (e) {
      window.addEventListener(e, playVids, { passive: true });
    });
    window.addEventListener('load', playVids);
  }

  function init(root) {
    root = root || document;
    reveals(root);
    faqs(root);
    bindTimelines(root);
    bindLayers(root);
    bindVideos(root);
    bindGlobals();
  }

  window.hnInit = init;

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Theme Editor: re-wire when a section is added, moved or re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
